import React from 'react'
import PropTypes from 'prop-types'
import useStyle from 'shared/hooks/useStyle'

import Header from './Header'

import styles from './Layout.style'

const propTypes = {
    children: PropTypes.node.isRequired,
    onClickMainMenu: PropTypes.func,
}

const Layout = ({
    children,
    onClickMainMenu,
}) => {
    const classes = useStyle(styles)

    return (
        <div css={classes.container}>
            <Header onClickMainMenu={onClickMainMenu} />
            <div css={classes.content}>
                {children}
            </div>
        </div>
    )
}

Layout.propTypes = propTypes

export default Layout
